import styles from './OrgIcon.module.css';

interface OrgIconProps {
  name: string;
  /** Data-URL icon, or null/undefined to show the initial fallback. */
  icon?: string | null;
  /** Square size in px. */
  size?: number;
  className?: string;
}

/**
 * Square org icon: the uploaded image when present, otherwise a colored
 * initial derived from the org name. Decorative — callers supply the
 * accessible label on the surrounding control.
 */
export function OrgIcon({ name, icon, size = 32, className }: OrgIconProps) {
  const initial = name.trim().charAt(0).toUpperCase() || '?';
  return (
    <span
      className={`${styles.icon}${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {icon ? (
        <img src={icon} alt="" className={styles.img} />
      ) : (
        <span className={styles.fallback} style={{ fontSize: Math.round(size * 0.46) }}>
          {initial}
        </span>
      )}
    </span>
  );
}
